import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import { Spin } from 'antd';
import SprayCalculator from '@client/feature/sprayCalculator';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';

const root = document.getElementById('sprayCalculator');

/**
 * Suspense fallback for loading state
 */
const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-screen">
    <Spin size="large" />
  </div>
);

/**
 * Spray Calculator App
 * Multi-step calculator for determining spray quantities
 * based on tank capacity, area, and product formulations
 *
 * @returns {Element}
 * @constructor
 */
const SprayCalculatorApp = () => {
  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <Suspense fallback={<LoadingFallback />}>
            <SprayCalculator />
          </Suspense>
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 */
ReactDOM.createRoot(root).render(<SprayCalculatorApp />);
